export const CHAT_SEARCH_TAGS = ['All', 'Escalated'];

export const MAX_LIMITS = {
	fileUpload: 3,
	websiteUpload: 2,
	websiteUrl: 5,
	testChats: 10,
};

export const USER_TYPES = [
	{
		key: 'RU',
		name: 'Root User',
		label: 'RootUser',
	},
	{
		key: 'SBU',
		name: 'SandBox User',
		label: 'SandBoxUser',
	},
];

export const TOOLTIPS = {
	chat: 'This is a simulated integrated chat, similar to how an end-user would experience the bot on WhatsApp or your website. Consultant takeover features can only be tried in the active test chat session within the sandbox experience',
	file: '',
	url: 'Enter your Sitemap URL to let the bot learn from your website. Usually found at yourdomain.com/sitemap.xml',
	uriLink: '',
	numberList:
		'Each test chat appears under a Test User Name. Consultant features are available only for the active test session (top chat). Messages sent here will also reflect in the test chat (and vice versa) to experience the open view of end-user and bot conversations. ',
};
